import styled from 'styled-components';

export const ContainerLimit = styled.div`
  max-width: 1400px;
  width: 100%;
  min-width: 340px;
  margin: 0 auto;
`;
